import { h, Component } from 'preact';
import s from 'components/bolt/upWorld/planet.sss';
import { joinClasses } from 'utils/utils';
import { getDateNum } from 'utils/querySimulation';
import Store from 'store/store';
export default class Planet extends Component {

	constructor(props) {
		super(props);

		this.props = props;
		//this.handlePlanetClick = this.handlePlanetClick.bind(this);

		this.state = {
			dateNum : 0
		};
	}

	componentDidMount() {
		this.setState({ dateNum: getDateNum() || 0 });
	}

	// handlePlanetClick() {
	// 	const { copy } = this.props;
	// 	Store.emit('CUSTOM_EVENT', {
	// 		category: 'up-world',
	// 		action: 'planet-click',
	// 	});
	// 	window.open(copy.$showtimesLink, '_blank');
	// }

	render({ imageRoot }) {
		return (
			//update image later
			<div class={s.container}>
				<button class={s.planet}>
					<img src={`${imageRoot}/up/z5tvby/${this.state.dateNum}.webp`} />
				</button>
			</div>
		);
	}

}